import React, { Component } from "react";
import { Localization } from "../common/Localization";
import NasnimanyCiarovyKod from "../common/SnimanieCiarovehoKodu/NasnimanyCiarovyKod";
import LoadingPanel from "../common/LoadingPanel";
import DialogWindow from "../common/DialogWindow";
import { dateConvert } from "../common/Helpers";
import { animateScroll as scroll } from "react-scroll";

import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { prijemBalikaController } from "../../controllers/prijembalika.controller";
import { Button } from "@progress/kendo-react-buttons";
import TovarFoto from "../common/TovarFoto";
import KeyboardEventHandler from "react-keyboard-event-handler";
import { ValueTypeEnum, ButtonGroupEnum, ButtonMessageEnum, MessageTypeEnum, CiarovyKodAllowedHandleKeys, RoleNames, TypTovaru, LogLevel } from "../../enums";
import { Zvuky } from "../common/Zvuky";
import testZvukovService from "../common/testZvukovService";
import cookie from "react-cookies";
import promptService from "../common/promptService";
import confirmService from "../common/confirmService";
import Moment from "moment";
import VyberDodavekDialogContent from "./PrijomDodavok/VyberDodavekDialogContent";
import SkenGrid from "./PrijemBalika/SkenGrid";
import RozdielGrid from "./PrijemBalika/RozdielGrid";
import NovaFarbaDialogContent from "./PrijemBalika/NovaFarbaDialogContent";
import GetPrijemArtikelFromCiarovyKod from "../common/SnimanieCiarovehoKodu/GetPrijemArtikelFromCiarovyKod";
import { authenticationService } from "../../services/authentication.service";
import { logController } from "../../controllers/log.controller";
import PolozkaBezKoduVyberDialogContent from "./PrijemBalika/PolozkaBezKoduVyberDialogContent";
import { nahlasenieDodavkyController } from "../../controllers/nahlaseniedodavky.controller";

class PrijemBalikaDialogContent extends Component {
    state = {
        idBalik: null,
        balik: null,
        selectedId: null,
        selectedIdVariant: null,
        pocetKs: null,
        loading: true,
        dialog: {
            title: null,
            content: null,
            width: null,
            height: null
        },
        confirmDialog: {
            show: false
        },
        keyboardEventHandlerDisabled: false,
        skenProgress: false
    };

    componentDidMount() {
        this.switchKeyboardEventHandler(true);

        prijemBalikaController.getBalikByCiarovyKod(this.props.zadanyKod).then(async (response) => {
            if (response.errorMessage) {
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage,
                    logMessage: true
                });
                this.props.toggleDialog(true);
                return;
            }
            if (response.vyberDodavek.length > 0) {
                this.showVyberDodavkyDialog(response);
            } else {
                this.afterDataLoaded(response);
            }
        });
    }

    switchKeyboardEventHandler = (isDisabled) => {
        this.setState({ keyboardEventHandlerDisabled: isDisabled });
        console.debug(`PrijemBalikaDialogContent.switchKeyboardEventHandler => isDisabled = ${isDisabled}`);
    };

    showVyberDodavkyDialog = (response) => {
        var localizationService = provideLocalizationService(this);
        let data = JSON.parse(JSON.stringify(response), dateConvert);
        this.setState({
            dialog: {
                title: localizationService.toLanguageString("PríjemVýberDod.Výber dodávky tovaru", "Výber dodávky tovaru"),
                content: (onClose) => <VyberDodavekDialogContent toggleDialog={onClose} dodavky={data.vyberDodavek} zvolitDodavku={this.zvolitDodavku} />,
                height: "400px",
                width: "862px",
                extraClosingCallback: (isByCloseButton) => {
                    if (isByCloseButton) this.props.toggleDialog(true);
                }
            }
        });
    };

    /**
     * Volá se po návratu dat ze serveru při otevření dialogu.
     *
     * @param {*} response
     * @memberof PrijemBalikaDialogContent
     */
    async afterDataLoaded(balik) {
        var localizationService = provideLocalizationService(this);
        this.setState({
            balik: balik,
            loading: false,
            pocetKs: null
        });

        this.props.changeTitle(localizationService.toLanguageString("PríjemBalíka.Príjem tovaru", "Príjem tovaru") + " - " + balik.nadpisDodavky);

        logController.logMessage("Príjem balíka " + balik.packing + " - otvorení okna");

        if (balik.balikNaviac) {
            var message = balik.suToKUSY ? "<P1> nemá obsahovať samostatné kusy !" : "Balík <P1> je naviac v dodávke !";
            message = localizationService.toLanguageString("PríjemBalíka." + message, message);
            message = message.replace(/<P1>|\{0}/, balik.nadpisDodavky);
            var message2 = balik.suToKUSY ? "Chcete naozaj pridať samostatné kusy do dodávky ?" : "Chcete ho naozaj pridať do dodávky ?";
            message2 = localizationService.toLanguageString("PríjemBalíka." + message2, message2);
            const confirmResult = await confirmService.show({
                message: message + "<br/>" + message2,
                buttons: ButtonGroupEnum.OK_CANCEL,
                logMessage: true
            });
            if (confirmResult != ButtonMessageEnum.OK) {
                this.props.toggleDialog(true);
                return;
            }
        }

        if (balik.jeMaterial) {
            var messagePotvrdit = localizationService.toLanguageString("PríjemBalíka.Potvrdiť príjem materiálu ?", "Potvrdiť príjem materiálu ?");
            var messageKs = localizationService.toLanguageString("PríjemBalíka.ks", "ks");
            const confirmResult = await confirmService.show({
                message: `${messagePotvrdit}\r\n${balik.packingNazov}\r\n${balik.materialNazov}\r\n${balik.materialPocetKs} ${messageKs}`,
                buttons: ButtonGroupEnum.OK_CANCEL,
                logMessage: true
            });
            if (confirmResult != ButtonMessageEnum.OK) {
                this.props.toggleDialog(true);
                return;
            }
            prijemBalikaController.jeMaterial(balik).then(async (response) => {
                if (response.errorMessage) {
                    await confirmService.show({
                        type: response.messageType,
                        message: response.errorMessage,
                        logMessage: true
                    });
                }
                this.props.reloadNahlasNenahlasDodavkyGrid();
            });
            this.props.toggleDialog(true);
            return;
        }

        if (balik.suToTasky) {
            var messagePotvrdit = localizationService.toLanguageString("PríjemBalíka.Potvrdiť príjem balíka tašiek ?", "Potvrdiť príjem balíka tašiek ?");
            var messageKs = localizationService.toLanguageString("PríjemBalíka.ks", "ks");
            const confirmResult = await confirmService.show({
                message: `${messagePotvrdit}\r\n${balik.pocetPol} ${messageKs}`,
                buttons: ButtonGroupEnum.OK_CANCEL,
                logMessage: true
            });
            if (confirmResult != ButtonMessageEnum.OK) {
                this.props.toggleDialog(true);
                return;
            }
            prijemBalikaController.suToTasky(balik).then(async (response) => {
                if (response.errorMessage) {
                    await confirmService.show({
                        type: response.messageType,
                        message: response.errorMessage,
                        logMessage: true
                    });
                }
                this.props.reloadNahlasNenahlasDodavkyGrid();
            });
            this.props.toggleDialog(true);
            return;
        }

        var gPrebeholTestZvukov = cookie.load("gPrebeholTestZvukov");
        if (gPrebeholTestZvukov != "true") {
            await testZvukovService.show();
        }

        // kontrola, či dodávka už bola prijatá
        var idTyp = balik.typTovaru == TypTovaru.P ? -1 : balik.idDodavka;
        if (!balik.skupinaDodavokUzBolaPrijata) {
            Zvuky.playChyba();

            logController.logMessage("Príjem balíka " + balik.packing + " - začiatok potvrdenia");

            var message = idTyp == -1 ? "Príjem presunov z <P1> ešte nebol potvrdený !" : "Príjem dodávky z <P1> ešte nebol potvrdený !";
            message = localizationService.toLanguageString("PríjemBalíka." + message, message);
            message = message.replace(/<P1>|\{0}/, Moment(balik.datumExpedicie).format("D.M.YYYY H:mm"));
            await confirmService.show({
                message: message,
                logMessage: true
            });
            message = idTyp == -1 ? "Zadajte dátum a čas príchodu presunov:" : "Zadajte dátum a čas príchodu dodávky:";
            message = localizationService.toLanguageString("PríjemBalíka." + message, message);
            const promptResult = await promptService.show({
                message: message,
                valueType: ValueTypeEnum.DATETIME,
                logMessage: true
            });
            if (promptResult.button != ButtonMessageEnum.OK) {
                this.props.toggleDialog(true);
                return;
            }
            var datum = Moment(promptResult.value, "D.M.YYYY H:mm", true);
            if (!datum.isValid()) {
                Zvuky.playChyba();
                await confirmService.show({
                    message: localizationService.toLanguageString(
                        "PríjemBalíka.Zadajte dátum aj čas príchodu dodávky !",
                        "Zadajte dátum aj čas príchodu dodávky !"
                    )
                });
                this.props.toggleDialog(true);
                return;
            }
            if (!datum.isBetween("2010-01-01", undefined)) {
                Zvuky.playChyba();
                await confirmService.show({
                    message: localizationService.toLanguageString("PríjemBalíka.Neplatný zadaný dátum !", "Neplatný zadaný dátum !")
                });
                this.props.toggleDialog(true);
                return;
            }

            logController.logMessage("Príjem balíka " + balik.packing + " - dátum a čas potvrdenia " + datum.format("YYYY-MM-DD HH:mm"));

            prijemBalikaController
                .potvrditPrijemDodavky(balik.idDodavka, balik.idBalik, balik.ciarovyKodDodavky, true, false, datum.format("YYYY-MM-DDTHH:mm:ss"), true)
                .then(async (response) => {
                    if (response.isError) {
                        Zvuky.playChyba();
                        await confirmService.show({
                            message: "Príjem balíka " + balik.packing + " - Chyba potvrdenie prijmu dodavky: " + response.errorMessage,
                            logMessage: true
                        });
                        this.props.toggleDialog(true);
                        return;
                    } else {
                        this.props.reloadSpravyGrid();
                        this.props.reloadNahlasNenahlasDodavkyGrid();
                    }
                });
            // notifikačný email
            prijemBalikaController.notifikacniEmail(datum.format("YYYY-MM-DDTHH:mm:ss"), balik.datumExpedicie, balik.idDodavka).then(async (response) => {
                if (response.isError) {
                    Zvuky.playChyba();
                    await confirmService.show({
                        message: response.errorMessage,
                        logMessage: true
                    });
                    this.props.toggleDialog(true);
                    return;
                }
            });
        }

        this.props.balikIsChanged();

        this.switchKeyboardEventHandler(false);

        Zvuky.playPozor();

        logController.logMessage("Príjem balíka " + balik.packing + " - koniec otvorenia okna");
    }

    handleKeyEvent(key, e) {
        this.setState({
            keyboardEvent: e
        });
        e.preventDefault();
        return false;
    }

    async handleTestKeyEvent(key, e) {
        switch (key) {
            case "shift+a":
                // A - celý balík OK
                var balik = this.state.balik;
                for (let i = 0; i < balik.pocetPol; i++) {
                    balik.lenNenaskenovany = true;
                    var response = await prijemBalikaController.TEMP_CiarovyKodZBalika(balik);
                    if (response.isError) {
                        Zvuky.playChyba();
                        await confirmService.show({
                            message: response.errorMessage,
                            logMessage: true
                        });
                        return;
                    }
                    if (response.validaceFarbaPolozka) {
                        balik = await this.potvrditFarbuArtikla(response);
                    } else {
                        await this.GetNewArtikel(response);
                        balik = response;
                    }
                }
                break;
            case "shift+b":
                // B - tovar z balíka
                var balik = this.state.balik;
                balik.lenNenaskenovany = false;
                prijemBalikaController.TEMP_CiarovyKodZBalika(balik).then(async (response) => {
                    if (response.isError) {
                        Zvuky.playChyba();
                        await confirmService.show({
                            message: response.errorMessage,
                            logMessage: true
                        });
                        return;
                    }
                    this.GetNewArtikel(response);
                });
                break;
            case "shift+c":
                // C - tovar z balíka nenaskenovaný
                var balik = this.state.balik;
                balik.lenNenaskenovany = true;
                prijemBalikaController.TEMP_CiarovyKodZBalika(balik).then(async (response) => {
                    if (response.isError) {
                        Zvuky.playChyba();
                        await confirmService.show({
                            message: response.errorMessage,
                            logMessage: true
                        });
                        return;
                    }
                    this.GetNewArtikel(response);
                });
                break;
            case "shift+d":
                // D - tovar mimo balíka
                var balik = this.state.balik;
                prijemBalikaController.TEMP_CiarovyKodMimoBalika(balik).then(async (response) => {
                    if (response.isError) {
                        Zvuky.playChyba();
                        await confirmService.show({
                            message: response.errorMessage,
                            logMessage: true
                        });
                        return;
                    }
                    this.GetNewArtikel(response);
                });
                break;
            case "shift+e":
                // E - tovar mimo balíka - len farba
                var balik = this.state.balik;
                prijemBalikaController.TEMP_CiarovyKodZBalika_InaFarba(balik).then(async (response) => {
                    if (response.isError) {
                        Zvuky.playChyba();
                        await confirmService.show({
                            message: response.errorMessage,
                            logMessage: true
                        });
                        return;
                    }
                    this.GetNewArtikel(response);
                });
                break;
            case "shift+f":
                // F - tovar mimo balíka - len veľkosť
                var balik = this.state.balik;
                prijemBalikaController.TEMP_CiarovyKodZBalika_InaVelkost(balik).then(async (response) => {
                    if (response.isError) {
                        Zvuky.playChyba();
                        await confirmService.show({
                            message: response.errorMessage,
                            logMessage: true
                        });
                        return;
                    }
                    this.GetNewArtikel(response);
                });
                break;
            case "shift+g":
                // G - tovar mimo balíka - len bez kódu farby
                var balik = this.state.balik;
                balik.lenBezKoduFarby = true;
                prijemBalikaController.TEMP_CiarovyKodMimoBalika(balik).then(async (response) => {
                    if (response.isError) {
                        Zvuky.playChyba();
                        await confirmService.show({
                            message: response.errorMessage,
                            logMessage: true
                        });
                        return;
                    }
                    this.GetNewArtikel(response);
                });
                break;
        }
        e.preventDefault();
        return false;
    }

    SetSkenProgress = async () => {
        if (this.state.skenProgress) {
            await Zvuky.playChyba();
            return false;
        }
        this.setState({
            skenProgress: true
        });
        return true;
    };

    GetNewArtikel = async (response) => {
        var localizationService = provideLocalizationService(this);

        if (response.isError) {
            Zvuky.playChyba();
            await confirmService.show({
                type: response.messageType,
                message: response.errorMessage,
                logMessage: true
            });
            this.enableUkonceni();
            return;
        }

        // Pokud je nová farba tak zobrazit dialog
        if (response.validaceFarbaPolozka) {
            if (
                Array.isArray(response.validaceFarbaPolozka.tagy) &&
                response.validaceFarbaPolozka.tagy.some((tag) => tag.toLowerCase() === "!check this artikl!")
            ) {
                Zvuky.playNotification();
            } else {
                Zvuky.playPozor();
            }
            this.switchKeyboardEventHandler(true);
            this.setState({
                dialog: {
                    title:
                        localizationService.toLanguageString("PríjemBalíka.Potvrdenie artikla a farby", "Potvrdenie artikla a farby") +
                        ` - ${response.validaceFarbaPolozka.cisloKarty}/${response.validaceFarbaPolozka.farba} ${response.validaceFarbaPolozka.popis}`,
                    content: (onClose) => (
                        <NovaFarbaDialogContent
                            toggleDialog={onClose}
                            response={response}
                            skenPolozka={response.validaceFarbaPolozka}
                            zlyArtikel={this.zlyArtikel}
                            potvrdit={this.potvrditFarbuArtikla}
                        />
                    ),
                    extraClosingCallback: () => {
                        this.switchKeyboardEventHandler(false);
                    },
                    height: "555px",
                    width: "572px"
                }
            });
            return;
        }

        await this.pridatKus(response);
    };

    potvrditFarbuArtikla = async (balik) => {
        var skenPolozka = balik.validaceFarbaPolozka;
        var response = await prijemBalikaController.refreshStavSkenovaniaPoloziekBalika(balik).catch((error) => {
            logController.logMessage("PrijemBalikaDialogContent.potvrditFarbuArtikla: " + error, LogLevel.Error);
            return {
                errorMessage: `Server vrátil chybu po potvrdení artikla a farby (artikl: ${skenPolozka.cisloKarty}/${skenPolozka.farba} ${skenPolozka.popis}, balík: ${balik.packing}). Chyba byla zaznamenána do logu.\n\nZkuste prosím naskenovat čiarový kód artikla znovu.`,
                isError: true
            };
        });
        if (response.isError) {
            Zvuky.playChyba();
            await confirmService.show({
                type: MessageTypeEnum.EXCLAMATION,
                message: response.errorMessage,
                logMessage: true
            });
            this.enableUkonceni();
            return;
        }
        logController.logMessage(
            `Přidání kusu po potvrzení barvy (Id: ${skenPolozka.id}): ${skenPolozka.cisloKarty}/${skenPolozka.farba} ${skenPolozka.popis} (balík ${balik.packing})`
        );
        await this.pridatKus(response);
        return response;
    };

    polozkaBezKodu = async () => {
        var localizationService = provideLocalizationService(this);

        this.switchKeyboardEventHandler(true);
        const promptResult = await promptService.show({
            message: localizationService.toLanguageString("PríjemBalíka.Číslo artikla:", "Číslo artikla:"),
            valueType: ValueTypeEnum.TEXT,
            logMessage: true
        });
        if (promptResult.button != ButtonMessageEnum.OK) {
            this.switchKeyboardEventHandler(false);
            return;
        }

        prijemBalikaController.validacePolozkyBezKodu(promptResult.value).then(async (response) => {
            this.switchKeyboardEventHandler(false);
            if (response.errorMessage) {
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage
                });
                return;
            }

            this.setState({
                dialog: {
                    title: localizationService.toLanguageString("PríjemBezKódu.Príjem balíka - položka bez kódu", "Príjem balíka - položka bez kódu"),
                    content: (onClose) => (
                        <PolozkaBezKoduVyberDialogContent toggleDialog={onClose} response={response} pridatKus={this.GetNewArtikel} balik={this.state.balik} />
                    ),
                    height: "415px",
                    width: "862px"
                }
            });
        });
    };

    pridatKus = async (response) => {
        var pridanyKus = response.poleSKEN[response.poleSKEN.length - 1];
        var pridanyKusId = pridanyKus.id;
        var pridanyKusIdVariant = pridanyKus.idVariant;
        var pridanyKusIdKarta = pridanyKus.idKarta;

        // Kontrola, zda počet naskenovaných položek odpovídá Id přidaného kusu.
        // Pokud neodpovídá, tak došlo k příliš rychlému skenování a předběhnutí odpovědí na odesílané požadavky.
        if (this.state.balik.poleSKEN.length + 1 != pridanyKusId) {
            logController.logMessage(
                `Došlo k příliš rychlému skenování a předběhnutí odpovědí na přidané kusy (počet PoleSKEN: ${this.state.balik.poleSKEN.length}, přidané Id: ${pridanyKusId}, balík ${this.state.balik.packing})`,
                LogLevel.Error
            );
        }

        this.setState({
            balik: response,
            selectedId: pridanyKusId,
            selectedIdVariant: pridanyKusIdVariant,
            selectedIdKarta: pridanyKusIdKarta,
            skenProgress: false
        });

        this.scrollToBottom();

        if (pridanyKus.rozdielyStav === 1 /* enspOK */) {
            await Zvuky.playOk();
        } else {
            await Zvuky.playPozor();
        }
    };

    zlyArtikel = async () => {
        var localizationService = provideLocalizationService(this);
        await confirmService.show({
            type: MessageTypeEnum.EXCLAMATION,
            message: localizationService.toLanguageString(
                "clsPríjem.Zlý artikel alebo farba - vytlačte správne visačky k artiklu !",
                "Zlý artikel alebo farba - vytlačte správne visačky k artiklu !"
            ),
            logMessage: true
        });
        this.enableUkonceni();
    };

    scrollToBottom() {
        var divPrijemBalikaSkenGrid = document.getElementById("PrijemBalikaSkenGrid");
        if (divPrijemBalikaSkenGrid) {
            var container = divPrijemBalikaSkenGrid.getElementsByClassName("k-virtual-content");
            if (container) {
                scroll.scrollToBottom({
                    container: container[0]
                });
            }
        }
    }

    async componentWillReceiveProps(nextProps) {
        if (nextProps.showClosingConfirmDialog && nextProps.showClosingConfirmDialog != this.props.showClosingConfirmDialog) {
            await this.zrusitPrijemBalika();
        } else if (!nextProps.showClosingConfirmDialog && nextProps.showClosingConfirmDialog != this.props.showClosingConfirmDialog) {
            this.enableUkonceni();
        }
    }

    // confirmSaveBalik = () => {
    //     if (!this.validateVaha()) {
    //         return false;
    //     }
    //     this.props.closeConfirmDialog();
    //     this.toggleConfirmDialog();
    //     if (this.saveBalik()) {
    //         this.props.toggleDialog(true);
    //     }
    // };

    closeDialog = () => {
        this.props.toggleDialog(true);
    };

    zvolitDodavku = (iddodavka) => {
        prijemBalikaController.getBalikByCiarovyKod(this.props.zadanyKod, iddodavka).then(async (response) => {
            if (response.errorMessage) {
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage,
                    logMessage: true
                });
                this.props.toggleDialog(true);
                return;
            }
            this.afterDataLoaded(response);
        });
    };

    odebratKus = () => {
        prijemBalikaController.odebratKus(this.state.balik, this.state.selectedId).then(async (response) => {
            if (response.isError) {
                await confirmService.show({
                    type: MessageTypeEnum.EXCLAMATION,
                    message: response.errorMessage,
                    logMessage: true
                });
                return;
            }
            this.setState({
                balik: response,
                selectedId: null,
                selectedIdVariant: null,
                selectedIdKarta: null
            });
        });
    };

    setSelectedItem = (id, idVariant, idKarta) => {
        this.setState({
            selectedId: id,
            selectedIdVariant: idVariant,
            selectedIdKarta: idKarta
        });
    };

    enableUkonceni = () => {
        this.setState({
            ukonceniDisabled: false,
            skenProgress: false
        });
    };

    ukoncitBalik = async (e) => {
        if (e) e.currentTarget.disabled = true; // pro rychlý disable tlačítka pomocí JS
        this.setState({
            ukonceniDisabled: true,
            skenProgress: true
        });
        var balik = this.state.balik;

        var localizationService = provideLocalizationService(this);
        logController.logMessage("Ukončenie balíka " + balik.packing + " - začiatok");

        if (balik.poleSKEN.length === 0) {
            if (authenticationService.hasCurrentUserRole(RoleNames.Administrator)) {
                const confirmResult = await confirmService.show({
                    type: MessageTypeEnum.EXCLAMATION,
                    message: localizationService.toLanguageString(
                        "PríjemBalíka.Naozaj chcete ukončiť balík, ktorý neobsahuje žiadne naskenované položky ?",
                        "Naozaj chcete ukončiť balík, ktorý neobsahuje žiadne naskenované položky ?"
                    ),
                    buttons: ButtonGroupEnum.OK_CANCEL
                });
                if (confirmResult == ButtonMessageEnum.CANCEL) {
                    this.enableUkonceni();
                    return;
                }
            } else {
                await confirmService.show({
                    type: MessageTypeEnum.CRITICAL,
                    message: localizationService.toLanguageString(
                        "PríjemBalíka.Balík neobsahuje žiadne naskenované položky !",
                        "Balík neobsahuje žiadne naskenované položky !"
                    ),
                    logMessage: true
                });
                this.enableUkonceni();
                return;
            }
        }

        var jeMozneUkoncit = false;
        logController.logMessage("Ukončenie balíka " + balik.packing + " - kontrola");
        //Kontrola, jestli naskenovane polozky odpovidaji polozkam baliku
        if (balik.poleSKEN.length === balik.polePOL.length) {
            var tempPolePOL = [...balik.polePOL];
            for (let i = 0; i < balik.poleSKEN.length; i++) {
                var hledanyIndexPol = tempPolePOL.findIndex(
                    (item) => item.idVariant === balik.poleSKEN[i].idVariant && item.velkost === balik.poleSKEN[i].velkost
                );
                if (hledanyIndexPol === -1) {
                    break;
                } else {
                    tempPolePOL.splice(hledanyIndexPol, 1);
                }
                if (i === balik.poleSKEN.length - 1) {
                    jeMozneUkoncit = true;
                }
            }
        }

        if (!jeMozneUkoncit) {
            const confirmResult = await confirmService.show({
                type: MessageTypeEnum.EXCLAMATION,
                message: localizationService.toLanguageString(
                    "PríjemBalíka.Naskenovaný obsah balíka sa nezhoduje s tým, čo sa má v balíku nachádzať.",
                    "Naskenovaný obsah balíka sa nezhoduje s tým, čo sa má v balíku nachádzať."
                ),
                buttons: ButtonGroupEnum.OK_CANCEL
            });
            if (confirmResult == ButtonMessageEnum.OK) {
                jeMozneUkoncit = true;
            } else {
                this.enableUkonceni();
                return;
            }
        }

        logController.logMessage("Ukončenie balíka " + balik.packing + " - uloženie");

        var response = await prijemBalikaController.ulozitBalik(this.state.balik);
        if (response.isError) {
            await confirmService.show({
                type: MessageTypeEnum.CRITICAL,
                message: response.errorMessage,
                logMessage: true
            });
            this.enableUkonceni();
            return;
        }

        // if (!jeMozneUkoncit) {
        //     // DBSapp.ZápisLOG "Ukončenie balíka " & ObjB.Packing & " - JeMožnéUkončiť=FALSE"
        //     // If ObjB.OpakovanýSKEN Then
        //     //     MyBox TRN("PríjemBalíka", "Naskenovaný obsah balíka sa nezhoduje s predchádzajúcim skenovaním.") & vbCrLf & vbCrLf _
        //     //         & TRN("PríjemBalíka", "Naskenujte všetky kusy v balíku znovu !"), vbExclamation
        //     // Else
        //     //     MyBox TRN("PríjemBalíka", "Naskenovaný obsah balíka sa nezhoduje s tým, čo sa má v balíku nachádzať.") & vbCrLf & vbCrLf _
        //     //         & TRN("PríjemBalíka", "Pre overenie rozdielov naskenujte všetky kusy v balíku znovu !"), vbExclamation
        //     // End If
        //     // If ObjB.NastaviťOpakovanéSkenovanieBalíka() = False Then
        //     //     MyBox gChyba, vbCritical
        //     //     GoTo Zavri
        //     // End If
        //     // 'aktualizácia zobrazenia
        //     // Me.Caption = TRN("PríjemBalíka", "Príjem tovaru") & " - " & ObjB.NadpisDodávky(True)
        //     // Me!Nadpis = ObjB.NadpisBalíka(True)
        //     // Me!PočetKS = ""
        //     // Set Frm2 = Me!PodformulárFRM.Form
        //     // Frm2.Requery
        //     // Frm2!Popis.Caption = TRN("PríjemBalíka", "Naskenujte čiarové kódy" & vbCrLf & "všetkých kusov v balíku")
        //     // Frm2.Section(1).Visible = True
        //     // Frm2.DividingLines = False
        //     // Frm2.RecordSelectors = False
        //     // If ObjFOTO.PrázdneFoto = False Then
        //     //     MyBox gChyba, vbExclamation
        //     //     GoTo Zavri
        //     // End If
        // } else {

        // 'potvrdenie príjmu dodávky (len raz pri uložení prvého balíka z dodávky) - radšej tu, lebo pri pípnutí balíka by to držovalo kým by sa poslala správa a mohli kusy skenovať
        logController.logMessage("Ukončenie balíka " + balik.packing + " - JeMožnéUkončiť=TRUE");

        response = await prijemBalikaController.potvrditPrijemDodavky(
            balik.idDodavka,
            balik.idBalik,
            balik.ciarovyKodDodavky,
            true,
            false,
            balik.datumPrijmu,
            false
        );
        if (response.isError) {
            await confirmService.show({
                type: MessageTypeEnum.CRITICAL,
                message:
                    "Ukončenie balíka " +
                    balik.packing +
                    " - Chyba potvrdenie prijmu dodavky: " +
                    response.errorMessage +
                    "\r\nNahlásenie dodávky je potřeba provést manuálně. Kontaktujte prosím technickou podporu.",
                logMessage: true
            });

            // Balík byl již v pořádku uložen, takže je možné zavřít okno balíka, ale je potřeba nahlásit dodávku ručně
            this.props.reloadNahlasNenahlasDodavkyGrid();
            this.props.toggleDialog(true);

            return;
        }

        logController.logMessage("Ukončenie balíka " + balik.packing + " - Zistenie či je možné nahlásiť");
        //'nahlásenie dodávky ak sú naskenované všetky balíky (mimo Dachseru)
        var jeMozneNahlasitDodavku = await prijemBalikaController.jeMozneNahlasitDodavku(this.state.balik);
        if (jeMozneNahlasitDodavku.isError) {
            await confirmService.show({
                type: MessageTypeEnum.CRITICAL,
                message: response.errorMessage,
                logMessage: true
            });
        } else {
            logController.logMessage(`Ukončenie balíka ${balik.packing} - jeMozneNahlasit=${jeMozneNahlasitDodavku.jeMozneNahlasit}`);
            if (jeMozneNahlasitDodavku.jeMozneNahlasit) {
                var dodavka = await nahlasenieDodavkyController.getDodavkaById(balik.idDodavka);
                if (!dodavka || dodavka.isError) {
                    await confirmService.show({
                        type: MessageTypeEnum.CRITICAL,
                        message: "Nenájdená dodávka (ID:" + balik.idDodavka + ") !",
                        logMessage: true
                    });
                } else {
                    if (dodavka.skladFrom === 91 || (dodavka.skladFrom === 1 && dodavka.cisloDodavky >= 20000 && dodavka.cisloDodavky <= 39999)) {
                        nahlasenieDodavkyController
                            .nahlaseniDodavkyDachser(dodavka.idexpedicia, dodavka.cisloDodavky, dodavka.skladFrom)
                            .then(async (response) => {
                                // this.setState({
                                //     nahlasitDodavkuDisabled: false
                                // });
                                if (response.isError) {
                                    await confirmService.show({
                                        type: MessageTypeEnum.EXCLAMATION,
                                        message: response.errorMessage,
                                        logMessage: true
                                    });
                                    return;
                                }
                                if (response.msgBoxChyba) {
                                    await confirmService.show({
                                        type: MessageTypeEnum.EXCLAMATION,
                                        width: "700px",
                                        message: response.msgBoxChyba,
                                        logMessage: true
                                    });
                                }
                                if (response.msgBoxNaviac) {
                                    await confirmService.show({
                                        type: MessageTypeEnum.EXCLAMATION,
                                        message: response.msgBoxNaviac,
                                        logMessage: true
                                    });
                                }
                                this.props.openDialogNahlaseniKusy(response);
                            });
                    } else {
                        nahlasenieDodavkyController
                            .nahlaseniPresuny(true, dodavka.idexpedicia, dodavka.cisloDodavky, dodavka.skladFrom)
                            .then(async (response) => {
                                if (response.isError) {
                                    await confirmService.show({
                                        type: MessageTypeEnum.EXCLAMATION,
                                        message: response.errorMessage,
                                        logMessage: true
                                    });
                                }
                                this.props.reloadSpravyGrid();
                                this.props.reloadNahlasNenahlasDodavkyGrid();
                            });
                    }
                }

                logController.logMessage("Ukončenie balíka " + balik.packing + " - Po nahlásení");
            }
        }
        logController.logMessage("Ukončenie balíka " + balik.packing + " - Koniec");
        this.props.reloadNahlasNenahlasDodavkyGrid();
        this.props.toggleDialog(true);
    };

    zrusitPrijemBalika = async () => {
        var localizationService = provideLocalizationService(this);

        if (this.state.ukonceniDisabled) {
            this.props.closeConfirmDialog();
            return;
        }

        this.setState({
            ukonceniDisabled: true,
            skenProgress: true
        });

        if (this.state.balik.poleSKEN.length > 0) {
            const confirmResult = await confirmService.show({
                type: MessageTypeEnum.EXCLAMATION,
                message: localizationService.toLanguageString(
                    "PríjemBalíka.Naozaj chcete zrušiť balík, ktorý obsahuje naskenované položky ?",
                    "Naozaj chcete zrušiť balík, ktorý obsahuje naskenované položky ?"
                ),
                buttons: ButtonGroupEnum.OK_CANCEL
            });
            if (confirmResult == ButtonMessageEnum.OK) {
                prijemBalikaController.zrusitPrijem(this.state.balik).then((response) => {
                    this.closeDialog();
                });
            } else {
                this.props.closeConfirmDialog();
                this.enableUkonceni();
            }
        } else {
            prijemBalikaController.zrusitPrijem(this.state.balik).then((response) => {
                this.closeDialog();
            });
        }
    };

    /**
     * renderuje obsah dialogu.
     *
     * @returns
     * @memberof PrijemBalikaDialogContent
     */
    renderDialogContent() {
        var localizationService = provideLocalizationService(this);
        return this.state.balik.isError ? (
            <div className="alert alert-danger">{this.state.balik.errorMessage}</div>
        ) : (
            <div id="PrijemBalikaDialog">
                <KeyboardEventHandler
                    handleKeys={CiarovyKodAllowedHandleKeys}
                    onKeyEvent={(key, e) => this.handleKeyEvent(key, e)}
                    // isExclusive={true}
                    handleFocusableElements={true}
                    isDisabled={this.state.keyboardEventHandlerDisabled}
                />
                <NasnimanyCiarovyKod keyboardEvent={this.state.keyboardEvent}>
                    <GetPrijemArtikelFromCiarovyKod
                        balik={this.state.balik}
                        startRequest={this.SetSkenProgress}
                        skenProgress={this.state.skenProgress}
                        getArtikel={this.GetNewArtikel}
                    />
                </NasnimanyCiarovyKod>
                <KeyboardEventHandler
                    handleKeys={["shift+a", "shift+b", "shift+c", "shift+d", "shift+e", "shift+f", "shift+g"]}
                    onKeyEvent={(key, e) => this.handleTestKeyEvent(key, e)}
                    handleFocusableElements={true}
                    isDisabled={this.state.keyboardEventHandlerDisabled}
                />
                <div className="row">
                    <div className="col-xs-8">
                        {this.state.balik.balikNaviac ? (
                            <div className="alert alert-danger nadpis">{this.state.balik.nadpisBalika}</div>
                        ) : (
                            <div className="alert alert-warning nadpis">{this.state.balik.nadpisBalika}</div>
                        )}
                    </div>
                    <div className="col-xs-4">
                        <div className="row">
                            <div className="col-xs-6">
                                <Button icon="minus" className="font-bold" onClick={this.odebratKus}>
                                    <Localization
                                        messageKey={"PríjemBalíka.Odstrániť\r\npoložku"}
                                        defaultMessage={"Odstrániť\r\npoložku"}
                                        replaceNewLines={true}
                                    />
                                </Button>
                            </div>
                            <div className="col-xs-6">
                                <Button icon="close" className="auto-focus font-bold" onClick={this.zrusitPrijemBalika} disabled={this.state.ukonceniDisabled}>
                                    <Localization messageKey={"PríjemBalíka.Zrušiť\r\nbalík"} defaultMessage={"Zrušiť\r\nbalík"} replaceNewLines={true} />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-8">
                        <SkenGrid items={this.state.balik.poleSKEN} selectedId={this.state.selectedId} setSelectedItem={this.setSelectedItem} />
                        {this.state.skenProgress ? <LoadingPanel /> : <React.Fragment></React.Fragment>}
                    </div>
                    <div className="col-xs-4">
                        {this.state.selectedIdVariant ? (
                            <TovarFoto idVariant={this.state.selectedIdVariant} idKarta={this.state.selectedIdKarta} />
                        ) : (
                            <div className="tovar-foto"></div>
                        )}
                        <div className="row">
                            <div className="col-xs-6 pole-sken-pocet">
                                {this.state.balik.poleSKEN.length > 0 ? (
                                    <span>
                                        {this.state.balik.poleSKEN.length} <Localization messageKey={"PríjemBalíka.ks"} defaultMessage={"ks"} />
                                    </span>
                                ) : (
                                    <React.Fragment></React.Fragment>
                                )}
                            </div>
                            <div className="col-xs-6">
                                <Button icon="plus" className="font-bold" onClick={this.polozkaBezKodu}>
                                    <Localization
                                        messageKey={"PríjemBalíka.Položka\r\nbez kódu"}
                                        defaultMessage={"Položka\r\nbez kódu"}
                                        replaceNewLines={true}
                                    />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-xs-10">
                        <RozdielGrid items={this.state.balik.poleR} />
                    </div>
                    <div className="col-xs-2 text-center">
                        <Button icon="save" className="font-bold" onClick={this.ukoncitBalik} disabled={this.state.ukonceniDisabled}>
                            <Localization messageKey={"PríjemBalíka.Ukončiť\r\nbalík"} defaultMessage={"Ukončiť\r\nbalík"} replaceNewLines={true} />
                        </Button>
                    </div>
                </div>
                <DialogWindow dialog={this.state.dialog} />
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? (
            <div>
                <LoadingPanel />
                <DialogWindow dialog={this.state.dialog} />
            </div>
        ) : (
            this.renderDialogContent()
        );

        return <div>{contents}</div>;
    }
}

export default PrijemBalikaDialogContent;

registerForLocalization(PrijemBalikaDialogContent);



// WEBPACK FOOTER //
// ./src/components/dialogs/PrijemBalikaDialogContent.js